import { mapCountryCodeToDefaultCurrency } from '@seek/salary-data';

import { createGetPreviewCurrencyLabel } from './createGetPreviewCurrencyLabel';

export const getPreviewCurrencyLabel = createGetPreviewCurrencyLabel(
  mapCountryCodeToDefaultCurrency,
);
